import { useCallback, useEffect, useState } from 'react';
import { centroAyudaService, type ArticuloAyudaDto } from '@/services/api/centroAyuda.service';
import type { HelpArticle, HelpIconName, MediaType } from '../types';

function dtoToHelpArticle(dto: ArticuloAyudaDto): HelpArticle {
  return {
    id: dto.id,
    category: dto.categoria,
    icon: dto.icono as HelpIconName,
    title: dto.titulo,
    snippet: dto.snippet,
    media: dto.mediaTipo
      ? { type: dto.mediaTipo as MediaType, duration: dto.mediaDuracion, url: dto.mediaUrl }
      : undefined,
    steps: dto.pasos,
    active: dto.esActivo,
    order: dto.orden,
  };
}

export function useArticulosAyuda(soloActivos = true) {
  const [articulos, setArticulos] = useState<HelpArticle[]>([]);
  const [cargando, setCargando] = useState(true);

  const recargar = useCallback(async () => {
    setCargando(true);
    const res = await centroAyudaService.getArticulos(soloActivos);
    if (res.ok && res.data) setArticulos(res.data.map(dtoToHelpArticle));
    setCargando(false);
  }, [soloActivos]);

  useEffect(() => { void recargar(); }, [recargar]);

  const categorias = Array.from(new Set(articulos.map((a) => a.category)));

  return { articulos, categorias, cargando, recargar };
}
